export default "__VITE_ASSET__Cr3t8vu8__"